$(document).ready(function(){

  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2
  })

  /***************** Set height for product to equal *****************/
  //setTimeout(function(){
  //  equalHeight();
  //  $(window).resize(function(){equalHeight();});
  //},500);

   /***************** JS sort by collection *****************/
   Shopify.queryParams = {};
   if (location.search.length) {
     for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
       aKeyValue = aCouples[i].split('=');
       if (aKeyValue.length > 1) {
         Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
       }
     }
   }
   jQuery('#item-sort-by li, #item-sort-by-mb li')
     .val('{{ collection.sort_by | default: collection.default_sort_by | escape }}')
     .bind('click', function() {
       Shopify.queryParams.sort_by = jQuery(this).data('value');
       location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
   });

   /***************** Click show item sort by, filter app *****************/

   $('.title-sort').on('click',function(){
     if ($('#pt-nav-toggle').hasClass('active')) {
       $( "#pt-nav-toggle" ).trigger( "click" );
     }
     $(this).parent().toggleClass('active-sort-by');
   });

   $(document).click(function(e){
     var containerSort = $(".block-sort-by");
     var containerFilter = $(".filter-menu");
      if (!$(e.target).parents().addBack().is('.filter-group'))
      {
        containerFilter.removeClass('active-filter');
      }
      if (!$(e.target).parents().addBack().is('.block-sort-by'))
      {
        containerSort.removeClass('active-sort-by');
      }
   });

   $('.title-filter-app').on('click',function(){
     $(this).parents('.filter-menu').toggleClass('active-filter');
   });

   $('.pt-mobile-header #pt-nav-toggle').on('click',function(){
     $('.sort-by-mb').removeClass('active-sort-by');
   });

   /***************** JS add to cart *****************/
   var getFirstVariant = '';
   var getVariantIdProduct = '';
   var countItem2 = $('.addtocart').data('count');

   //get first variant each product
   $('.variant-product').each(function(){
     getFirstVariant = $(this).find('li:not([disabled="sold_out_product"])').eq(0).data('value');
     
     //if variant product sold out will disabled button add to shopping bag
     var checkSoldOut = $(this).find('li').attr('disabled');
     if (checkSoldOut) {
       $(this).find('li').parent().next().prop('disabled',true).text('SOLD OUT');
     } else{
       $(this).find('li').parent().next().prop('disabled',true).text('SELECT A SIZE');
     }
   });
  
   //get variantID when choose variant
   $('body').on('click','.variant-product li',function(){
     getVariantIdProduct = $(this).data('value');
     $(this).parents('.product-card').find('li').removeClass('active-vatiant');
     $(this).addClass('active-vatiant');

     //if variant product sold out will disabled button add to shopping bag
     var checkSoldOut = $(this).attr('disabled');
     if (checkSoldOut) {
       $(this).parent().next().prop('disabled',true).text('SOLD OUT');
     }else{
       $(this).parent().next().prop('disabled',false).text('ADD TO SHOPPING BAG');
     }
   });

   $('.addtocart').on('click',function(){
      var MiniCartItemsSelector = $('[mini-cart-items]');
      var MiniCartCountSelector = $('[mini-cart-count]');
      var MiniCartPriceTotalSelector = $('[mini-cart-total-price]');

     var checkFirstvariant = $(this).attr('data-first-variant');
     var buildCart ='' ;
     var imgProduct = '';
     if (typeof checkFirstvariant !== 'undefined') {
       var variantID = checkFirstvariant;
     }else{
       var variantID = getVariantIdProduct;
     }

     var button = $(this)
     var variantID = $(this).siblings('ul.variant-product').find('li.active-vatiant').attr('data-value')
     console.log(variantID)


     $.ajax({
       url:'/cart/add.js',
       type: 'POST',
       data:{id:variantID,quantity:1},
       dataType: 'json',
       success: function (result) {

          var atc = button.html()
          button.html('ADDED!')

          setTimeout(function(){
            button.html(atc)
          },4000);

         countItem2++;
         $('[mini-cart-count]').html(countItem2);
         // get cart contents
          jQuery.getJSON('/cart.js', function(cart) {
            //alert('There are now ' + cart.item_count + ' items in the cart.');
            
            // Loop through items and update mini cart content
            var itemMarkup = '';
            $(cart.items).each(function () {
              
              itemMarkup += '<li class="media" id="MiniCartItem-'+ this.key +'" data-item-id="'+ this.key +'" data-variant-id="'+ this.variant_id +'">';
              itemMarkup += '<div class="media-body">';
              itemMarkup += '<div class="row">';
              itemMarkup += '<div class="col-4 text-center">';
              itemMarkup += '<a href="'+ this.url +'"><img src="'+ this.image +'" alt="'+ this.title +'" class="img-fluid" /></a>';
              itemMarkup += '</div>';
              itemMarkup += '<div class="col-8">';
              itemMarkup += '<a href="'+ this.url +'"><h6 class="mb-0">'+ this.product_title +'</h6></a>';
              
              if (this.variant_title) {
                  itemMarkup += '<p class="small">';
                $(this.variant_options).each(function () {
                    itemMarkup += '<em>'+ this +'</em><br/>';
                });
                  itemMarkup += '</p>';
              }
                                              
              itemMarkup += '<div class="row">';
              itemMarkup += '<div class="col-7 small">'+ formatter.format(this.price / 100) +' x <span mini-cart-item-quantity>'+ this.quantity +'</span></div>';
              itemMarkup += '<div class="col-5 text-right  small font-bold">'+ formatter.format(this.line_price / 100) +'</div>';
              itemMarkup += '<a href="/cart/change?id='+this.variant_id+'&amp;quantity=0" class="text-secondary text-right mt-2 cart--remove"><small> Remove</small></a>'

              itemMarkup += '</div>';
              
              itemMarkup += '</div></div></li>';
            });
            
            // update cart contents
            MiniCartItemsSelector.html( itemMarkup );
            
            //update subtotal
            MiniCartPriceTotalSelector.html(  formatter.format(cart.total_price / 100) );
            
            // update cart count on badge and header
            MiniCartCountSelector.html( cart.item_count );

          } );
          
          // Toggle open the mini cart
          //$('.cart-mini .dropdown-menu').dropdown("toggle");

          //redirect go to cart page
          $('.mini-cart-div .btn-to-cart').on('click',function(){
            window.location.href="/cart";
          });

          //redirect go to product page
          $('.product-title-cart').on('click',function(){
            var url = $(this).parent().attr('href');
            window.location.href=url;
          });

          //after 4s mini cart on desktop will disappear
          setTimeout(function(){
            $('.cart-mini .dropdown-menu').removeClass('show');
          },4000);

          //after 4s mini cart on desktop will disappear
          setTimeout(function(){
            $('.cart-mini .dropdown-menu').removeClass('show');
          },4000);

       }
     });
   });

   //set height mini cart
   if ($(window).width() > 991) {
     if ($('.cart-mini .dropdown-menu').height() > 555 ) {
       $('.cart-mini .dropdown-menu').addClass('shorten-height-cart');
     }else{
       $('.cart-mini .dropdown-menu').removeClass('shorten-height-cart');
     }
   }

   if ($('.navbar #miniCart').height() > 555 ) {
     $('.navbar #miniCart').addClass('shorten-height-cart');
   }else{
     $('.navbar #miniCart').removeClass('shorten-height-cart');
   }
});

$(window).on('load',function(){
  $('.variant-product li.active-vatiant').each(function(){
    $(this).click().trigger('click')
  })
})

// function equalHeight(){
//   var highestBox = 0;
//   var windowWidth = $(window).width();
//     $('.item--template--collection').each(function(){
//        $(this).find('.card-img-top').each(function(){
//          if($(this).height() > highestBox){
//              highestBox = $(this).height();
//          }
//        });
//        $('.card-img-container').height(highestBox);
//      });
// }
